/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "227b3ea1debaa67dc39eb58d1472a338e088374a";
